import React from 'react';
import './PublishConfirmationModal.css';

const PublishConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    type = 'publish', 
    pageTitle = 'Your Page',
    hasChanges = false 
}) => {
    if (!isOpen) return null;

    const getModalConfig = () => {
        switch (type) {
            case 'publish':
                return {
                    icon: 'fas fa-rocket',
                    title: 'Publish Page',
                    subtitle: 'Make your page live',
                    description: `Your page "${pageTitle}" will be published and become visible to all visitors.`,
                    confirmText: 'Publish Now',
                    confirmClass: 'confirm-publish',
                    iconColor: '#10b981'
                };
            case 'deploy':
                return {
                    icon: 'fas fa-upload',
                    title: 'Deploy Changes',
                    subtitle: 'Update live page',
                    description: `Deploy your latest changes to "${pageTitle}". Visitors will see the updated version immediately.`,
                    confirmText: 'Deploy Now',
                    confirmClass: 'confirm-deploy',
                    iconColor: '#f59e0b'
                };
            case 'unpublish':
                return {
                    icon: 'fas fa-eye-slash',
                    title: 'Switch to Draft',
                    subtitle: 'Take page offline',
                    description: `"${pageTitle}" will be switched to draft mode and no longer visible to visitors. You can continue editing and publish again later.`,
                    confirmText: 'Switch to Draft',
                    confirmClass: 'confirm-unpublish',
                    iconColor: '#ef4444'
                };
            default:
                return {
                    icon: 'fas fa-question',
                    title: 'Confirm Action',
                    subtitle: 'Please confirm',
                    description: 'Are you sure you want to proceed?',
                    confirmText: 'Confirm',
                    confirmClass: 'confirm-default',
                    iconColor: '#6b7280'
                };
        }
    };

    const config = getModalConfig();

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="publish-modal-overlay" onClick={handleBackdropClick}>
            <div className="publish-modal">
                <div className="publish-modal-header">
                    <div className="publish-modal-icon" style={{ color: config.iconColor }}>
                        <i className={config.icon}></i>
                    </div>
                    <h3 className="publish-modal-title">{config.title}</h3>
                    <p className="publish-modal-subtitle">{config.subtitle}</p>
                </div>
                
                <div className="publish-modal-body">
                    <p className="publish-modal-description">
                        {config.description}
                    </p>
                    
                    {type === 'deploy' && hasChanges && (
                        <div className="changes-preview">
                            <div className="changes-icon">
                                <i className="fas fa-edit"></i>
                            </div>
                            <span>Latest changes will be deployed</span>
                        </div>
                    )}
                    
                    {type === 'publish' && (
                        <div className="publish-benefits">
                            <div className="benefit-item">
                                <i className="fas fa-globe"></i>
                                <span>Publicly accessible</span>
                            </div>
                            <div className="benefit-item">
                                <i className="fas fa-search"></i>
                                <span>SEO optimized</span>
                            </div>
                            <div className="benefit-item">
                                <i className="fas fa-share-alt"></i>
                                <span>Shareable link</span>
                            </div>
                        </div>
                    )}
                </div>
                
                <div className="publish-modal-actions">
                    <button 
                        className="publish-modal-cancel"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button 
                        className={`publish-modal-confirm ${config.confirmClass}`}
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                    >
                        <i className={config.icon}></i>
                        {config.confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PublishConfirmationModal;
